/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Fragment, useCallback, useEffect, useLayoutEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Up from '../images/angle_up.svg';
import Down from '../images/down.svg';
import NewActivity from './NewActivity';
import Activity from './Activity';
import dots from '../images/dots.svg';
import rev from '../assets/images/reverseButton.svg';
import mult_choice from '../images/mult_choice.png';
import free_response from '../images/free_response.png';
import order_list from '../images/free_response.png';
import { setActivityQuestions } from '../Store/entities/activityQuestions';
import fill_in_the_blank from '../images/fill_in_the_blank.png';
import matching from '../images/matching.png';
import { filter } from '../Store/api/activities';
import { setActivitiesLoader } from '../Store/ui/loaders';
import { Link } from 'react-router-dom';
import Cross from '../assets/images/x.svg';
import { ActivityOverlay } from '../shared/ActivityOverlay';
import storage from '../services/storage';
import { ModalPortal } from './ModalPortal';
import { CustomModal } from '../shared/CustomModal';
import { ActivityRightBarSkeleton } from '../shared/ActivityRightBarSkeleton';

const images = {
  mult_choice,
  free_response,
  fill_in_the_blank,
  matching,
  order_list,
};
const RightBar = ({
  mode,
  newActivities,
  setNewActivities = () => {},
  creatingActivity,
  setGreyedPharagraphs,
  activities = [],
  writingActivity,
  reverse,
  setCreatingActivity,
  setWritingActivity,
  setReverse,
  setHighlightedParagraph,
  setHighlightedSection,
  setHighlightedSections = () => {},
  setGreyedItem,
  scrollTo = () => {},
  setHighlightedIndexes,
  setDraggedOver,
  setDragging,
  setActivitySetModal,
  scrollToParagraph,
  setDraggedType,
  highlightedParagraph,
  setIsDraggingActivity,
  setDraggedActivityPosition,
  setDraggedActivity,
  showCalendar,
  greyedItemSetter,
  isDraggingActivity,
  draggedActivity,
  draggedChap,
  draggedOver,
  selectedParagraphs,
  setSelectedParagraphs = () => {},
  setSelectedSections = () => {},
  selectedSections = [],
  dragging,
  draggedActivityPosition,
  bookId = '',
  selectedActivity = {},
  activityElement,
  showClearBtn = false,
  onClear = () => {},
  activityFilter,
  ref,
}) => {
  const { book } = useSelector((state) => state.entities);
  const { openActivity } = useSelector((state) => state.ui.reader.reader);
  const { settings } = useSelector((state) => state.settings.settings);
  const templates = useSelector((state) => state.ui.templates);
  const { user } = useSelector((state) => state.auth);
  const { loaders } = useSelector((state) => state.ui);
  const [spreadActivities, setSpreadActivities] = useState([]);
  const [isCleared, setIsCleared] = useState(false);
  const [className, setClassName] = useState('');
  const [viewableActivities, setViewableActivities] = useState([]);
  // const [newActivities, setNewActivities] = useState([]);
  const [exploreActivities, setExploreActivities] = useState([]);
  const [tab, setTab] = useState('assign');
  const [filters, setFilters] = useState({
    own: false,
    author: false,
    all: true,
  });
  const [existingActivities, setExistingActivities] = useState(activities);
  const [draggs, setDraggs] = useState([]);
  const [previewActivity, setPreviewActivity] = useState(false);
  let timerId2 = null;
  const Storeuser = storage.get('user');
  const status = Storeuser?.status === 'waiting';
  const [showModal, setShowModal] = useState(status);
  const [userStatus, setUserStatus] = useState(false);

  const dispatch = useDispatch();
  const { activityDetials } = useSelector((state) => state.entities.activityQuestions);
  useEffect(() => {
    if (!creatingActivity) {
      timerId2 = setTimeout(() => {
        setClassName('d-none');
      }, 500); // Delay of 0.5 seconds (500 milliseconds)
    } else {
      setClassName('');
    }
    return () => {
      clearTimeout(timerId2); // Clean up the timeout on component unmount or state change
    };
  }, [creatingActivity]);

  useEffect(() => {
    setExistingActivities(activities);
  }, [activities]);
  useEffect(() => {
    setDraggs([]);
  }, [newActivities]);
  useEffect(() => {
    setHighlightedIndexes([]);
    setDraggedOver(null);
    setSpreadActivities([]);
  }, [tab, setDraggedOver, setHighlightedIndexes]);

  useEffect(() => {
    if (showCalendar === undefined || !showCalendar) {
      const assigned = existingActivities.filter((e) => e.assigned || e.assignedDate).length;
      const linked = existingActivities.filter((e) => !e.assigned && !e.assignedDate).length;
      if (assigned > 0 && linked === 0) {
        setTab('assign');
      } else if (linked > 0 && assigned === 0) {
        setTab('linked');
      }
    }
  }, [existingActivities, showCalendar]);

  const spreadActivitiesSetter = (id) => {
    if (spreadActivities.includes(id)) {
      setSpreadActivities(spreadActivities.filter((e) => e !== id));
    } else {
      setSpreadActivities([...spreadActivities, id]);
    }
  };

  const popNewActivity = (ind) => {
    // let neActs = [...newActivities];
    // neActs.splice(index, 1);
    // setNewActivities(neActs);
    setNewActivities((old) => old.filter((a, i) => a.id !== ind));
  };

  useEffect(() => {
    // dispatch(setActivitiesLoader(true));

    if (filters.all) {
      dispatch(
        filter({
          bookId,
          queryParams: { query: 'allauthors' },
          onSuccess: (res) => {
            setExistingActivities([
              ...activities.filter((e) => e.owner && e.owner._id === user._id),
              ...res.data.data,
            ]);
          },
        })
      );
    } else if (filters.own && !filters.author) {
      setExistingActivities(activities.filter((e) => e.owner && e.owner._id === user._id));
      // dispatch(setActivitiesLoader(false));
    } else if (filters.author && !filters.own) {
      setExistingActivities(activities.filter((e) => e.owner && e.owner._id !== user._id));
      // dispatch(setActivitiesLoader(false));
    } else {
      setExistingActivities(activities.filter((e) => e.owner));
      // dispatch(setActivitiesLoader(false));
    }
  }, [filters, activities, bookId, user._id, dispatch]);

  useEffect(() => {
    if (openActivity._id) {
      const div = document.getElementById(openActivity._id);

      if (div) {
        div.scrollIntoView({ block: 'start' });
        // setScrollToId(null);
      }
    }
  }, [openActivity, tab]);
  useEffect(() => {
    if (
      Object.keys(openActivity).length &&
      (!openActivity.assigned || !openActivity.assignedDate)
    ) {
      setTab('linked');
    } else {
      setTab('assign');
    }
  }, [openActivity]);

  const handleCheckBox = (value) => {
    if (value === 'all') {
      setFilters({ own: false, author: false, all: !filters['all'] });
    } else {
      setFilters((old) => {
        return { ...old, [value]: !old[value], all: false };
      });
    }
  };
  const onHide = useCallback(() => {
    setUserStatus(false);
    setShowModal(false);
  }, []);

  const handleDragStart = (e, template, index) => {
    setDragging(true);
    setDraggedType('activity');
    e.dataTransfer.setData('type', 'activity');
    e.dataTransfer.setData('template', template.type);
    setDraggs((old) => (!old.includes(index) ? [...old, index] : old.filter((e) => e !== index)));
  };
  useEffect(() => {
    setPreviewActivity(false);
    setViewableActivities([]);
  }, [creatingActivity]);

  const assignedActivities = loaders.activitiesLoader ?  [] : existingActivities
  .filter((e) => e.assigned && e.assignedDate)
  .filter((e) => selectedActivity?._id ? e._id === selectedActivity._id : true)

  const linkToBookActivities = loaders.activitiesLoader ?  [] : existingActivities
  .filter((e) => !e.assigned || !e.assignedDate)
  .filter((e) => e._id !== selectedActivity._id)

  return (
    <>
      <ModalPortal>
        <CustomModal
          isLink
          onHide={onHide}
          onAction={onHide}
          showModal={userStatus} //showModal ||
          actionBtnText='Done'
          title='not yet verified'
          cancelBtnText='Go to greyledteach'
          supportContent='support@greyled.com.'
          otherContent='You can still use the Greyled system but activities and their answers will be limited to protect the work of other professors.'
          content='The Greyled team is still working on verifying your professor status. If you have been waiting longer than 24 hours for professor validation, please contact '
        />
      </ModalPortal>
      <div
        className={` left_side_bar right_side_bar ${settings.bookMode ? 'd-none' : ''}`}
        style={{ height: 'calc(100vh - 70px)', overflowX: 'hidden' }}
      >
        {/*Creating new activity*/}
        <div
          className={`custom_nav templates_modal_inner  ${
            creatingActivity === undefined ? '' : !creatingActivity ? `animate-down` : 'animate-up'
          } ${className}`}
          id='templates_wrap'
          style={{
            display: creatingActivity === undefined ? 'none' : '',
          }}
        >
          <div className='inner_right'>
            <div
              className='collapse_btn top_postion'
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setCreatingActivity(false);
                setWritingActivity(false);
                setDraggedOver(null);
                setHighlightedIndexes([]);
                setReverse(false);
                setNewActivities([]);
                setSelectedParagraphs([]);
                setSelectedSections([]);
                dispatch(setActivityQuestions({}));
                setPreviewActivity(false);
              }}
            >
              <img
                src={Down}
                alt=''
                style={{
                  filter:
                    'grayscale(100%) sepia(30%) hue-rotate(240deg) brightness(90%) contrast(80%)',
                }}
              />
              <br />
              <a className='btn btn-link btn_back'>close</a>
            </div>
            <div className='inner-right-wrap'>
              <img
                className='cursor'
                src={rev}
                alt=''
                onClick={() => {
                  setReverse((old) => !old);
                }}
                style={{
                  position: 'absolute',
                  top: '12px',
                  left: `${reverse ? '93%' : '12px'}`,
                  transform: `${reverse ? 'rotate(-180deg)' : ''}`,
                  zIndex: 2,
                }}
              />
              <div className='p-sticky-right'>
                <div className='spacial-top-header'>
                  <ul className='nav nav-tabs nav-justified'>
                    {mode === 'create' && (
                      <li className='nav-item'>
                        <button
                          type='button'
                          className='nav-link active'
                          data-bs-toggle='tab'
                          data-bs-target='#create'
                          role='tab'
                          aria-controls='create'
                          aria-selected='true'
                        >
                          Create new activity
                        </button>
                      </li>
                    )}
                    <li className='nav-item'>
                      <button
                        type='button'
                        className={mode === 'assign' ? 'nav-link nav-link-activity' : 'nav-link'}
                        data-bs-toggle='tab'
                        data-bs-target='#explore'
                        role='tab'
                        disabled={mode === 'assign'}
                        aria-controls='explore'
                        aria-selected='true'
                      >
                        {mode === 'assign' ? 'explore activities' : 'explore'}
                      </button>
                    </li>
                  </ul>
                </div>
              </div>

              <div className='right_box_border multi_templates_wrap'>
                {mode === 'create' ? (
                  <div
                    className='tab-content'
                    style={{
                      height: 'calc(100vh - 180px)',
                      overflowY: 'scroll',
                    }}
                  >
                    <div
                      className='tab-pane fade show active'
                      id='create'
                      role='tabpanel'
                      aria-labelledby='create-tab'
                    >
                      {writingActivity ? (
                        <div>
                          {previewActivity && (
                            <Fragment>
                              {viewableActivities.map((act, i) => (
                                <Activity
                                  selectedSections={selectedSections}
                                  selectedParagraphs={selectedParagraphs}
                                  isCleared={isCleared}
                                  activity={act}
                                  setHighlightedIndexes={setHighlightedIndexes}
                                  setDraggedOver={setDraggedOver}
                                  chap={draggedChap}
                                  draggedOver={draggedOver}
                                  bookId={bookId}
                                  isNew={true}
                                  disableClose={false}
                                  previewActivity={previewActivity}
                                  setPreviewActivity={setPreviewActivity}
                                  mode='create'
                                />
                              ))}
                            </Fragment>
                          )}
                          {newActivities?.map((newActivity, index) => (
                            <NewActivity
                              chap={draggedChap}
                              pop={popNewActivity}
                              paragraphs={selectedParagraphs}
                              sections={selectedSections}
                              activity={newActivity}
                              index={index}
                              bookId={bookId}
                              setNewActivities={setNewActivities}
                              setViewableActivities={setViewableActivities}
                              setPreviewActivity={setPreviewActivity}
                            />
                          ))}

                          <div className='right_box_border dashed-border-box'>
                            <div className='f10 text-center mb-0'>
                              Add another{' '}
                              <div
                                className='Multiplechoice_wrap'
                                style={{ display: 'inline-flex' }}
                              >
                                <div className='btn-group'>
                                  <button
                                    type='button'
                                    className='btn btn-link dropdown-toggle'
                                    data-bs-toggle='dropdown'
                                    aria-expanded='false'
                                  >
                                    multiple-choice
                                  </button>
                                  <ul className='dropdown-menu'>
                                    {templates.map((temp, index) => (
                                      <li key={index}>
                                        <a
                                          href='#!'
                                          className='dropdown-item cursor'
                                          onClick={(e) => {
                                            e.preventDefault();
                                            setNewActivities((old) => [
                                              ...old,
                                              {
                                                book: bookId,
                                                id: Date.now(),
                                                name: '',
                                                description: '',
                                                score: '',
                                                type: temp.type,
                                                isShared: false,
                                                paragraphs: selectedParagraphs,
                                                sections: selectedSections,
                                                element: activityElement,
                                                questions: [
                                                  {
                                                    type: temp.type,
                                                    text: '',
                                                    description: '',
                                                    blanksBank: [],
                                                    bankQuestion: [],
                                                    score:
                                                      temp.type === 'mcqs'
                                                        ? 1
                                                        : temp.type === 'truefalse'
                                                        ? 0.5
                                                        : temp.type === 'fr'
                                                        ? 3
                                                        : temp.type === 'sa'
                                                        ? 1.5
                                                        : temp.type === 'blanks'
                                                        ? 0.5
                                                        : 0.25,
                                                    difficulty: 1,
                                                    sentence: '',
                                                    options:
                                                      temp.type === 'truefalse'
                                                        ? [
                                                            {
                                                              type: 'text',
                                                              text: 'True',
                                                              isCorrect: false,
                                                            },
                                                            {
                                                              type: 'text',
                                                              text: 'False',
                                                              isCorrect: false,
                                                            },
                                                          ]
                                                        : temp.type === 'mcqs'
                                                        ? []
                                                        : [],
                                                  },
                                                ],
                                              },
                                            ]);
                                          }}
                                        >
                                          {temp.name}
                                        </a>
                                      </li>
                                    ))}
                                  </ul>
                                </div>
                              </div>
                              activity to section
                            </div>
                          </div>
                        </div>
                      ) : (
                        <Fragment>
                          <Fragment>
                            {templates.map((template, index) => (
                              <div
                                style={{
                                  position: 'relative',
                                  minHeight: '143px',
                                  marginBottom: '16px',
                                }}
                                key={index}
                              >
                                <div
                                  draggable
                                  id={template.type}
                                  onDragStart={(e) => {
                                    handleDragStart(e, template, index);
                                  }}
                                  onDragEnd={() => {
                                    setDraggedOver(null);
                                    setDraggedType('');
                                    setDragging(false);
                                    setDraggs([]);
                                  }}
                                  style={{
                                    position: 'absolute',
                                    width: `${draggs.includes(index) ? '98%' : '100%'}`,
                                    opacity: 1,
                                    top: 0,
                                    left: draggs.includes(index) ? 3 : 0,
                                    zIndex: draggs.includes(index) ? 0 : 1,
                                  }}
                                >
                                  {' '}
                                  <div
                                    className={`multi_templates ${
                                      draggs.includes(index) ? 'dragging' : ''
                                    }`}
                                  >
                                    <div
                                      className={`div_three`}
                                      style={{
                                        transform: draggs.includes(index) ? 'none' : '',
                                      }}
                                    >
                                      <div
                                        className='div_two'
                                        style={{
                                          transform: draggs.includes(index) ? 'none' : '',
                                        }}
                                      >
                                        <div
                                          className='div_one'
                                          style={{
                                            transform: draggs.includes(index) ? 'none' : '',
                                          }}
                                        >
                                          <div className='content'>
                                            <div
                                              className='icon_tamplet'
                                              style={{
                                                height: draggs.includes(index) ? '144px' : '',
                                              }}
                                            >
                                              <img
                                                src={dots}
                                                style={{
                                                  pointerEvents: 'none',
                                                }}
                                                className='img-fluid'
                                                alt='dots'
                                              />
                                            </div>
                                            <h1>{template.name}</h1>
                                            {!dragging ? (
                                              <span>
                                                drag to the book to create linked activity
                                              </span>
                                            ) : (
                                              ''
                                            )}
                                            <img
                                              style={{ pointerEvents: 'none' }}
                                              src={images[template.image]}
                                              className='img-fluid mt-2'
                                              alt={template.name}
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className='multi_templates disable_templates'
                                  style={{
                                    position: 'absolute',
                                    width: '100%',
                                    top: 0,
                                    left: 0,
                                    zIndex: draggs.includes(index) ? 1 : 0,
                                    pointerEvents: 'none',
                                    display: `${draggs.includes(index) ? '' : 'none'}`,
                                  }}
                                >
                                  {' '}
                                  <div className='div_three'>
                                    <div className='div_two'>
                                      <div className='div_one'>
                                        <div className='content'>
                                          <div className='icon_tamplet'>
                                            <img src={dots} className='img-fluid' alt='dots' />
                                          </div>
                                          <h1>{template.name}</h1>
                                          <img
                                            src={images[template.image]}
                                            className='img-fluid mt-2'
                                            alt={template.name}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </Fragment>
                        </Fragment>
                      )}
                    </div>
                    <div
                      className='tab-pane fade'
                      id='explore'
                      role='tabpanel'
                      aria-labelledby='explore-tab'
                    >
                      {(book.activitiesSet !== 'original' || mode === 'create') && (
                        <Fragment>
                          {existingActivities
                            .filter((e) => e.owner === user._id)
                            .map((activity, index) => (
                              <Fragment key={index}>
                                <Activity
                                  selectedSections={selectedSections}
                                  selectedParagraphs={selectedParagraphs}
                                  isCleared={isCleared}
                                  setGreyedPharagraphs={setGreyedPharagraphs}
                                  setHighlightedParagraph={setHighlightedParagraph}
                                  setHighlightedIndexes={setHighlightedIndexes}
                                  setDraggedOver={setDraggedOver}
                                  setHighlightedSection={setHighlightedSection}
                                  setGreyedItem={setGreyedItem}
                                  mode={mode}
                                  spreadActivitiesSetter={spreadActivitiesSetter}
                                  key={index}
                                  activity={activity}
                                  index={index}
                                  highlightedParagraph={highlightedParagraph}
                                  setIsDraggingActivity={setIsDraggingActivity}
                                  setDraggedActivityPosition={setDraggedActivityPosition}
                                  scrollTo={scrollTo}
                                  setDraggedActivity={setDraggedActivity}
                                  isDraggingActivity={isDraggingActivity}
                                  showCalendar={showCalendar}
                                  greyedItemSetter={greyedItemSetter}
                                  bookId={bookId}
                                />

                                {isDraggingActivity &&
                                  draggedActivity &&
                                  draggedActivity._id === activity._id && (
                                    <div
                                      className=''
                                      style={{
                                        position: 'fixed',
                                        top: `${draggedActivityPosition.top}%`,
                                        left: `${draggedActivityPosition.left + 0.5}%`,
                                        zIndex: 9,
                                        width: '5.8%',
                                      }}
                                    >
                                      <div className='custom-event assigned-event'>
                                        <div className='event-title'>{activity.title}</div>
                                      </div>
                                    </div>
                                  )}
                              </Fragment>
                            ))}
                        </Fragment>
                      )}
                    </div>
                  </div>
                ) : (
                  <Fragment>
                    {exploreActivities.length ? (
                      <div></div>
                    ) : (
                      <div className='empty-explore-state'>
                        <p>No shared activities at this time</p>
                        <p>
                          You can create and publish activities for your students or for other
                          professors <Link to={`/create/${bookId}`}>here</Link>.
                        </p>
                      </div>
                    )}
                  </Fragment>
                )}
              </div>
            </div>
          </div>
          <div
            style={{
              height: '100%',
              width: '6px',
              background: 'var(--Grey-200, #F0F0EF)',
            }}
            className='side-div'
          ></div>
          <div
            style={{
              height: '100%',
              width: '8px',
              background: 'var(--Grey-300, #E6E5E4)',
            }}
            className='side-div'
          ></div>
          <div
            style={{
              height: '100%',
              width: '10px',
              background: 'var(--Grey-400, #D2CFCB)',
              borderTopRightRadius: '6px',
            }}
            className='side-div'
          ></div>
        </div>

        <div>
          <div className='activity-header-wrap header_poistion mb-0'>
            <div className='custom_nav' style={{ width: '90%' }}>
              <div className='custom-sticky-header'>
                <div style={{ width: '87%', margin: '0px auto' }}>
                  <ul className='nav nav-tabs nav-justified'>
                    <li
                      className='nav-item cursor'
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        if (Storeuser?.status === 'waiting') setUserStatus(true);
                        setTab('assign');
                      }}
                    >
                      <button
                        type='button'
                        className={`nav-link ${tab === 'assign' ? 'active' : ''}`}
                        data-bs-toggle='tab'
                        data-bs-target='#assigned'
                        role='tab'
                        aria-controls='assigned'
                        aria-selected='true'
                      >
                        Assigned (
                        {
                          activities
                            .filter((e) => e.owner && user && e.owner._id === user._id) // Check if e.owner and user are defined
                            .filter((item) => item.assigned).length
                        }
                        )
                      </button>
                    </li>
                    <li
                      className='nav-item cursor'
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        if (Storeuser?.status === 'waiting') setUserStatus(true);
                        setTab('linked');
                      }}
                    >
                      <button
                        type='button'
                        className={`nav-link ${tab === 'linked' ? 'active' : ''}`}
                        data-bs-toggle='tab'
                        data-bs-target='#linked'
                        role='tab'
                        aria-controls='linked'
                        aria-selected='true'
                      >
                        Linked to book (
                        {
                          activities
                            .filter((e) => e.owner && user && e.owner._id === user._id)
                            .filter((item) => !item.assigned).length
                        }
                        )
                      </button>
                    </li>
                  </ul>
                </div>
                <div className='d-flex align-items-center justify-content-between gap-1 my-3'>
                  <div
                    className={`cursor custom_filter ${filters.all ? 'active' : ''}`}
                    onClick={(e) => {
                      e.stopPropagation();
                      if (filters.all) {
                        return;
                      } else {
                        handleCheckBox('all');
                      }
                    }}
                  >
                    All authors
                    {filters.all && (
                      <img
                        width={12}
                        height={12}
                        src={Cross}
                        alt=''
                        onClick={(e) => {
                          e.stopPropagation();
                          handleCheckBox('all');
                        }}
                      ></img>
                    )}
                  </div>

                  <div
                    className={`cursor custom_filter ${filters?.own ? 'active' : ''}`}
                    onClick={(e) => {
                      e.stopPropagation();
                      if (filters?.own) {
                        return;
                      } else {
                        handleCheckBox('own');
                      }
                    }}
                  >
                    My activities (
                    {tab === 'assign' &&
                      activities
                        .filter((e) => e.owner && user && e.owner._id === user._id) // Check if e.owner and user are defined
                        .filter((item) => item.assigned).length}
                    {tab === 'linked' &&
                      activities
                        .filter((e) => e.owner && user && e.owner._id === user._id) // Check if e.owner and user are defined
                        .filter((item) => !item.assigned).length}
                    ){' '}
                    {filters.own && (
                      <img
                        width={12}
                        height={12}
                        src={Cross}
                        alt=''
                        onClick={(e) => {
                          e.stopPropagation();
                          handleCheckBox('own');
                        }}
                      />
                    )}
                  </div>

                  <div
                    className={`cursor custom_filter ${filters.author ? 'active' : ''}`}
                    onClick={() => {
                      if (filters.author) {
                        return;
                      } else {
                        handleCheckBox('author');
                      }
                    }}
                  >
                    Original authors (
                    {
                      activities.filter((e) => e.owner && user && e.owner._id !== user._id).length // Check if e.owner and user are defined
                    }
                    ){' '}
                    {filters.author && (
                      <img
                        width={12}
                        height={12}
                        src={Cross}
                        alt=''
                        onClick={(e) => {
                          e.stopPropagation();
                          handleCheckBox('author');
                        }}
                      ></img>
                    )}
                  </div>
                </div>
                {showClearBtn && (
                  <button
                    className='rounded-1 bg-transparent f-14 text-black btn_black_theme w-100 border-1 mb-2'
                    onClick={() => {
                      onClear();
                      setIsCleared(true);
                      setTimeout(() => {
                        setIsCleared(false);
                      }, 300);
                    }}
                  >
                    Close selected text and activities
                  </button>
                )}
              </div>
              <div
                className='tab-content'
                style={{
                  height: 'calc(100vh - 229px)',
                  overflowY: 'scroll',
                  paddingBottom: '16px',
                }}
              >
                <div
                  className={`tab-pane ${tab === 'assign' ? 'active show' : ''}`}
                  id='assigned'
                  role='tabpanel'
                  aria-labelledby='assigned-tab'
                >
                  {!loaders.activitiesLoader ? (
                    <Fragment>
                      {assignedActivities.length > 0 ? 
                        assignedActivities.map((activity, index) => (
                          <Fragment key={activity._id}>
                            <Activity
                              key={activity._id}
                              selectedSections={selectedSections}
                              selectedParagraphs={selectedParagraphs}
                              isCleared={isCleared}
                              setGreyedPharagraphs={setGreyedPharagraphs}
                              setHighlightedIndexes={setHighlightedIndexes}
                              setDraggedOver={setDraggedOver}
                              setHighlightedParagraph={setHighlightedParagraph}
                              setHighlightedSection={setHighlightedSection}
                              setHighlightedSections={setHighlightedSections}
                              setGreyedItem={setGreyedItem}
                              mode={mode}
                              spreadActivitiesSetter={spreadActivitiesSetter}
                              scrollTo={scrollTo}
                              activity={activity}
                              index={index}
                              highlightedParagraph={highlightedParagraph}
                              setIsDraggingActivity={setIsDraggingActivity}
                              setDraggedActivityPosition={setDraggedActivityPosition}
                              greyedItemSetter={greyedItemSetter}
                              setDraggedActivity={setDraggedActivity}
                              isDraggingActivity={isDraggingActivity}
                              showCalendar={showCalendar}
                              pickLib='assign'
                              bookId={bookId}
                            />

                            {isDraggingActivity &&
                              draggedActivity &&
                              draggedActivity._id === activity._id && (
                                <div
                                  className=''
                                  style={{
                                    position: 'fixed',
                                    top: `${draggedActivityPosition.top}%`,
                                    left: `${draggedActivityPosition.left + 0.5}%`,
                                    zIndex: 9,
                                    width: '5.8%',
                                  }}
                                >
                                  <div className='custom-event assigned-event'>
                                    <div className='event-title'>{activity.title}</div>
                                  </div>
                                </div>
                              )}
                          </Fragment>
                        )):
                        <div className='d-flex justify-content-center pt-4 fst-normal fs-16'>
                          <b className='text_grey fw-bold'>
                            Create a new activity to add to your network
                          </b>
                        </div>
                      }
                    </Fragment>
                  ) : (
                    [...new Array(4)].map((_, index) => <ActivityRightBarSkeleton key={index} />)
                  )}
                  {book.activitiesSet === null && <div style={{ height: '5vh' }}></div>}
                </div>
                <div
                  className={`tab-pane ${tab === 'linked' ? 'active show' : ''}`}
                  id='linked'
                  role='tabpanel'
                  aria-labelledby='linked-tab'
                >
                  {!loaders.activitiesLoader ? (
                    <Fragment>
                      {linkToBookActivities.length ? 
                        linkToBookActivities.map((activity, index) => (
                          <Fragment key={activity._id}>
                            <Activity
                              key={activity._id}
                              selectedSections={selectedSections}
                              selectedParagraphs={selectedParagraphs}
                              isCleared={isCleared}
                              setGreyedPharagraphs={setGreyedPharagraphs}
                              setHighlightedParagraph={setHighlightedParagraph}
                              setHighlightedSection={setHighlightedSection}
                              setHighlightedSections={setHighlightedSections}
                              setHighlightedIndexes={setHighlightedIndexes}
                              setDraggedOver={setDraggedOver}
                              setGreyedItem={setGreyedItem}
                              scrollTo={scrollTo}
                              mode={mode}
                              spreadActivitiesSetter={spreadActivitiesSetter}
                              scrollToParagraph={scrollToParagraph}
                              activity={activity}
                              index={index}
                              highlightedParagraph={highlightedParagraph}
                              setIsDraggingActivity={setIsDraggingActivity}
                              setDraggedActivityPosition={setDraggedActivityPosition}
                              greyedItemSetter={greyedItemSetter}
                              setDraggedActivity={setDraggedActivity}
                              isDraggingActivity={isDraggingActivity}
                              showCalendar={showCalendar}
                              bookId={bookId}
                              setNewActivities={setNewActivities}
                            />
                            {isDraggingActivity &&
                              draggedActivity &&
                              draggedActivity._id === activity._id && (
                                <div
                                  className=''
                                  style={{
                                    position: 'fixed',
                                    top: `${draggedActivityPosition.top}%`,
                                    left: `${draggedActivityPosition.left + 0.5}%`,
                                    zIndex: 9,
                                    width: '5.8%',
                                  }}
                                >
                                  <div className='custom-event assigned-event'>
                                    <div className='event-title'>{activity.title}</div>
                                  </div>
                                </div>
                              )}
                          </Fragment>
                        )): 
                          <div className='d-flex justify-content-center pt-4 fst-normal fs-16'>
                            <b className='text_grey fw-bold'>
                              Create a new activity to add to your network
                            </b>
                          </div>
                        }
                    </Fragment>
                  ) : (
                    [...new Array(4)].map((_, index) => <ActivityRightBarSkeleton key={index} />)
                  )}
                  {book.activitiesSet === null && <div style={{ height: '5vh' }}></div>}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style={{ position: 'relative', bottom: '-6px', left: '2px', width: '99.6%' }}>
          {!creatingActivity && !writingActivity ? (
            <button
              type='button'
              className='create_btn left_bottom_btn h-50px'
              // style={{ width: mode === "assign" ? "30%" : "25%" }}
              onClick={(e) => {
                if (mode === 'create') {
                  setCreatingActivity(true);
                } else if (book.activitiesSet === null || book.activitiesSet === 'original') {
                  setActivitySetModal({
                    show: true,
                    choice: 'own',
                  });
                } else {
                  setCreatingActivity(true);
                }
              }}
            >
              {mode === 'assign' ? 'Explore activities' : 'Create your own activity'}{' '}
              <img src={Up} alt='up' />
            </button>
          ) : (
            ''
          )}

          {((Storeuser?.role === 'PROFESSOR' && Storeuser?.status === 'waiting') ||
            userStatus) && <ActivityOverlay />}
        </div>
      </div>
    </>
  );
};

export default RightBar;
